// All of them accept array as well as return array


export const normilizeShowtimesReturnValue = result => result?.map(obj => {
  const {start_at_raw, ...res} = obj;
  res.start_at = start_at_raw;
  return res;
})

export const normilizeShowtimesInputValue = inputData => inputData.map(obj => {
  const { attribute_codes, ...rest } = obj; // strip array field not in DB schema
  return {
    ...rest,
    start_at_raw: obj.start_at,
    start_at: new Date(obj.start_at),
  }
})

export const normilizeMovieInputValue = inputData => inputData.map(obj => {
  return {
    ...obj,
    release_dates: JSON.stringify(obj.release_dates),
    genres: obj.genres && typeof obj.genres === 'object' ? JSON.stringify(obj.genres) : obj.genres,
    cast_list: obj.cast_list && typeof obj.cast_list === 'object' ? JSON.stringify(obj.cast_list) : obj.cast_list,
  }
})

export const normilizeMovieReturnValue = inputData => inputData.map(obj => {
  // 2026-07-21 OUTAGE LESSON: this parse ran bare, so ONE record with a non-string
  // release_dates (two heal-script writes stored raw objects) threw here and took
  // the ENTIRE movie map down for every visitor — year-less film links + "Film not
  // found" site-wide. Tolerate both storage shapes and never throw.
  let releaseDates = obj.release_dates;
  try { if (typeof releaseDates === 'string') releaseDates = JSON.parse(releaseDates); } catch { releaseDates = null; }
  let genres = obj.genres;
  let castList = obj.cast_list;
  try { if (typeof genres === 'string') genres = JSON.parse(genres); } catch { /* keep as-is */ }
  try { if (typeof castList === 'string') castList = JSON.parse(castList); } catch { /* keep as-is */ }
  const result = {
    ...obj,
    release_dates: releaseDates,
    genres: genres || null,
    cast_list: castList || null,
  };
  return result
})

export const moderationInfoInputValue = inputValue => JSON.stringify(inputValue);
export const moderationInfoReturnValue = returnValue => {
  if (returnValue == null || typeof returnValue !== 'string') return returnValue ?? null;
  try { return JSON.parse(returnValue); } catch { return null; }
};